import React from "react";
import { useNavigate } from "react-router-dom";

export default function LabDiamondSection() {

	const navigate = useNavigate();

	const handleClick = () => {
		navigate("/product-range");
	};

	return (
		<>
			<div className="lab-section-container px-2">
				<div className="lab-section">
					<div className="row align-items-center justify-content-center">

						<div className="lab-section-text col-md-6 text-center pb-5" data-aos="fade-right">
							<h2 className="section-subtitle text-primary">
								Designs Optimized for Lab <br /> Grown Diamonds
							</h2>
							<p className="description text-primary">
								Unlike natural diamonds, lab grown diamonds open up a world of
								possibilites for designing. Keeping the potential in mind, we do not
								just make natural diamond designs with lab grown diamonds. We
								passionately create new designs that are optimized for lab grown
								diamonds keeping aesthetic and profitability in mind.
							</p>
							<div className="text-center">
								<button className="primary-button" onClick={handleClick}>Explore Product Range</button>
							</div>
						</div>

						<div className="col-md-6 text-center" data-aos="fade-left">
							<img
								src="/assets/images/aboutus/image5.png"  
								alt="Lab Grown Diamond Jewelry"
								className="img-fluid lab-image"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
